export default {
  common: {
    home: 'Accueil',
    about: 'À propos',
    search: 'Rechercher',
    loading: 'Chargement...',
    noData: 'Aucune donnée',
    loadMore: 'Charger plus',
    backTop: 'Retour en haut',
    articles: 'Articles',
    tags: 'Tags',
    feedback: 'Commentaires',
    all: 'Tout',
    confirm: 'Confirmer',
    cancel: 'Annuler',
    submit: 'Soumettre',
    reset: 'Réinitialiser',
    prev: 'Précédent',
    next: 'Suivant',
    page: 'Page {n}',
    total: '{n} articles',
    sortBy: 'Trier',
    filterBy: 'Filtrer',
    newest: 'Plus récent',
    hottest: 'Plus populaire',
    notFound: 'Page non trouvée',
    notFoundDesc: 'La page que vous recherchez n\'existe pas',
    backHome: 'Retour à l\'accueil',
    language: 'Langue',
  },
  nav: { nba: 'NBA', cba: 'CBA', international: 'International', equipment: 'Équipement', training: 'Entraînement', culture: 'Culture' },
  news: { latest: 'Dernières nouvelles', hot: 'Nouvelles populaires', featured: 'En vedette', related: 'Nouvelles connexes', views: 'vues', source: 'Source', publishTime: 'Publié', articleList: 'Articles' },
  feedback: { title: 'Commentaires', name: 'Nom', email: 'E-mail', message: 'Message', namePlaceholder: 'Entrez votre nom', emailPlaceholder: 'Entrez votre e-mail', messagePlaceholder: 'Entrez vos commentaires', submitSuccess: 'Merci pour vos commentaires !', submitFail: 'Échec de l\'envoi, veuillez réessayer', nameRequired: 'Le nom est requis', emailRequired: 'L\'e-mail est requis', emailInvalid: 'Format d\'e-mail invalide', messageRequired: 'Le message est requis' },
  about: { title: 'À propos', siteName: 'Nom du site', domain: 'Domaine', category: 'Catégorie', email: 'E-mail de contact', description: 'Description', descContent: 'Ce site est un sous-site du réseau B530CF, le contenu est publié automatiquement après collecte et révision centralisées' },
  tag: { title: 'Nuage de tags', articlesWithTag: 'Articles avec ce tag' },
  site: { name: 'Monde du Basket', slogan: 'L\'actualité mondiale du basket à portée de main', copyright: '© 2026 Monde du Basket. Tous droits réservés.' },
}
